import { useStarredBoardsListPageQuery } from './StarredBoardsListPageQuery.generated';

export class MissingStarredBoardsDataError extends Error {
  constructor() {
    const message = 'Failed to load data from useStarredBoardsListPageQuery';
    super(message);
    this.name = 'MissingStarredBoardsDataError';
  }
}

interface UseStarredBoardsListPage {
  boardIds: string[];
  skip?: boolean;
}

export const useStarredBoardsListPage = ({
  boardIds,
  skip,
}: UseStarredBoardsListPage) => {
  const skipQuery = skip || !boardIds.length;

  // eslint-disable-next-line @trello/no-apollo-refetch
  const { data, error, loading, refetch } = useStarredBoardsListPageQuery({
    variables: { boardIds },
    skip: skipQuery,
  });

  /*
    There is a known issue where our Apollo/GraphQL implementation returns
    undefined for data, loading, and error. We create a specific instance
    of error in these cases, so that we can report it as a non-error
    operational event.
  */
  const invalidDataError =
    !loading && !error && !data?.boards && !skipQuery
      ? new MissingStarredBoardsDataError()
      : undefined;

  return { data, error: error || invalidDataError, loading, refetch };
};
